export const MODEL_INJECTION_KEY = Symbol('class-tender-model');
export const FILES_INJECTION_KEY = Symbol('class-tender-files');
export const SUBMITTING_INJECTION_KEY = Symbol('class-tender-submitting');
export const STEPS = {
	CANDIDATE_DATA: 0,
	PROJECT_DATA: 1,
	SUMMARY: 2
};
export const CATEGORY_OPTIONS = [
	{ key: 'BUILDING_COMMUNITY', value: 'Közösségépítés' },
	{ key: 'IMPROVING_SCHOOL_ENVIRONMENT', value: 'Iskolai környezet fejlesztése' }
];
